module.exports = __webpack_public_path__ + "static/ProximaNovaExCn-Semibold-3b507bf7c13f54a0c737646f00b4c3cc.woff";